
export class LightSyntaxHighlight {

    public _Point     = "#000000";
    public _Circle    = "#ffffff";
    public _Sequence  = "#3080ff";
    public _Prism     = "#30c0ff";
    public _Structure = "#30bf10";
    public _Tree      = "#96cf11";
    public _Manifold  = "#ffbc20";
    public _Function  = "#ff20fa";
    public _Procedure = "#ffc0fa";
    public _Class     = "#ca90ff";

}
